import React from "react";
import cs from "classnames";

import "./UserViewType.scss";

export const UserViewType = () => {
  return <div className={cs("UserViewType")}>Coordinator view</div>;
};
